import React from 'react';
import classNames from 'classnames';

import styles from './PersonalisedMenteeEmailersConfirmDetailInfo.module.scss';

export default function PersonalisedMenteeEmailersConfirmDetailInfo({
  label,
  detail,
}) {
  return (
    <div className={classNames(styles.root, 'p-l-l')}>
      <div className={styles.header}>{label}</div>
      <div className={classNames(styles.content, 'm-t-xxs')}>{detail}</div>
    </div>
  );
}
